
import { Product } from "@/models/base";
import Vue from "vue";
import AppSellPrices from "./ProductInfoSellPrices.vue";
import AppLabel from "@/components/common/InfoInput.vue";
import AppProductInfoGroups from "./ProductInfoGroups.vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	props: {
		product: {
			type: Object as () => Product,
			required: true
		}
	},
	computed: {
		unitName():string {
			if (!this.product.Unit) {
				return "";
			}
			return this.product.Unit.DisplayedName;
		},
		activeText():TranslateResult {
			if (this.product.Active) {
				return this.$ct("Active");
			}
			return this.$ct("Not-active");
		},
		discountsAllowedText():TranslateResult {
			if (this.product.DiscountsDisabled){
				return this.$ct("Discounts-disabled");
			}
			return this.$ct("Discounts-enabled");
		}
	},
	components: {
		AppSellPrices,
		AppLabel,
		AppProductInfoGroups
	},
	i18nEx: {
		componentPrefix: "components.products"
	},
});
